import { CalendarDays, Plus, X } from "lucide-react";

export default function DayTabs({ days, activeDay, setActiveDay, addDay, removeDay, renameDayInline }) {
  return (
    <div className="flex items-center gap-1.5 border-b border-slate-200 pb-2 overflow-x-auto" data-testid="day-tabs">
      {days.map((day, idx) => (
        <div key={idx}
          className={`group flex items-center gap-1 px-3 py-1.5 rounded-t-lg text-sm font-medium cursor-pointer transition-colors flex-shrink-0 ${
            activeDay === idx ? 'bg-slate-900 text-white' : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
          }`}
          onClick={() => setActiveDay(idx)}
          data-testid={`day-tab-${idx}`}
        >
          <CalendarDays className="w-3.5 h-3.5" />
          <input
            value={day.name}
            onChange={e => renameDayInline(idx, e.target.value)}
            onClick={e => { e.stopPropagation(); setActiveDay(idx); }}
            className={`bg-transparent border-none outline-none w-16 text-center text-xs font-medium ${
              activeDay === idx ? 'text-white placeholder-white/60' : 'text-slate-600'
            }`}
          />
          {days.length > 1 && (
            <button
              onClick={(e) => { e.stopPropagation(); removeDay(idx); }}
              className={`opacity-0 group-hover:opacity-100 transition-opacity ${
                activeDay === idx ? 'text-white/70 hover:text-white' : 'text-slate-400 hover:text-red-500'
              }`}
            >
              <X className="w-3 h-3" />
            </button>
          )}
          <span className="text-[10px] opacity-70">({day.exercises?.length || 0})</span>
        </div>
      ))}
      <button
        onClick={addDay}
        className="px-2 py-1.5 rounded-lg bg-slate-50 hover:bg-slate-100 text-slate-500 transition-colors flex-shrink-0"
        data-testid="add-day-btn"
      >
        <Plus className="w-4 h-4" />
      </button>
    </div>
  );
}
